import Stack from "@mui/material/Stack"
import { useState } from "react"

import Button from "@components/button"
import AddCouponCodeDialog from "@components/dialogs/add_coupon_code_to_customer"
import ExtendReduceDialog from "@components/dialogs/extend_reduce"
import MarkPyementAsPaidDialog from "@components/dialogs/mark_payement_as_paid"
import FeatureDialog from "@components/dialogs/plan_features"
import PlanLimitsAndUsages from "@components/dialogs/plan_limits_and_usages"
import RemoveCouponCodeDialog from "@components/dialogs/remove_coupon_code_from_customer"
import SetAccountBalance from "@components/dialogs/set_account_balance"
import SpecialOfferDialog from "@components/dialogs/special_offer"
import UpdateSpecialOffer from "@components/dialogs/special_offer_update"
import UpgradePlanDialog from "@components/dialogs/upgrade_plan"
import UpdateAccountBalance from "@components/dialogs/update_account_balance"
import { useCustomerPageContext } from "@contexts/customer"
import { Product } from "__generated__/graphql"

type CurrentPlanButtonsProps = {
  products?: Product[]
}

export default function CurrentPlanButtons({
  products
}: CurrentPlanButtonsProps) {
  const [openSpecial, setOpenSpecial] = useState(false)
  const [updateSpecial, setUpdateSpecial] = useState(false)

  const [openAddCouponCode, setOpenAddCouponCode] = useState(false)
  const [openRemoveCouponCode, setOpenRemoveCouponCode] = useState(false)

  const [openMarkPayement, setOpenMarkPayement] = useState(false)
  const [openExtendReduce, setOpenExtendReduce] = useState(false)
  const [openFeature, setOpenFeature] = useState(false)
  const [openUpdateAccountBalance, setOpenUpdateAccountBalance] =
    useState(false)
  const [openSetAccountBalance, setOpenSetAccountBalance] = useState(false)
  const [openUsagesAndLimits, setOpenUsagesAndLimits] = useState(false)
  const [openUpgradePlan, setOpenUpgradePlan] = useState(false)

  const { translate, currentCustomer } = useCustomerPageContext()
  const specialProduct = products?.find((item) => item.name === "Special")
  const customerCouponCode = currentCustomer?.package?.couponCode

  const buttons = (
    <Stack gap={1}>
      <Stack gap={1} direction={"row"}>
        {specialProduct ? (
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#E2EEFF",
              color: "black",
              ":hover": {
                backgroundColor: "#cce0fc"
              }
            }}
            onClick={() => setUpdateSpecial(true)}
          >
            {translate("update_special_offer")}
          </Button>
        ) : (
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#E2EEFF",
              color: "black",
              ":hover": {
                backgroundColor: "#cce0fc"
              }
            }}
            onClick={() => setOpenSpecial(true)}
          >
            {translate("special_offer")}
          </Button>
        )}

        {customerCouponCode ? (
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#E2EEFF",
              color: "black",
              ":hover": {
                backgroundColor: "#cce0fc"
              }
            }}
            onClick={() => setOpenRemoveCouponCode(true)}
          >
            {translate("remove_coupon_code")}
          </Button>
        ) : (
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#E2EEFF",
              color: "black",
              ":hover": {
                backgroundColor: "#cce0fc"
              }
            }}
            onClick={() => setOpenAddCouponCode(true)}
          >
            {translate("add_coupon_code")}
          </Button>
        )}

        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#E2EEFF",
            color: "black",
            ":hover": {
              backgroundColor: "#cce0fc"
            }
          }}
          onClick={() => setOpenExtendReduce(true)}
        >
          {translate("extend_reduce")}
        </Button>
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#E2EEFF",
            color: "black",
            ":hover": {
              backgroundColor: "#cce0fc"
            }
          }}
          onClick={() => setOpenUpgradePlan(true)}
        >
          Upgrade Plan
        </Button>
      </Stack>
      <Stack gap={1} direction={"row"}>
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#E2EEFF",
            color: "black",
            ":hover": {
              backgroundColor: "#cce0fc"
            }
          }}
          onClick={() => setOpenSetAccountBalance(true)}
        >
          {translate("update_account_balance")}
        </Button>
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#E2EEFF",
            color: "black",
            ":hover": {
              backgroundColor: "#cce0fc"
            }
          }}
          onClick={() => setOpenFeature(true)}
        >
          {translate("features")}
        </Button>
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#E2EEFF",
            color: "black",
            ":hover": {
              backgroundColor: "#cce0fc"
            }
          }}
          onClick={() => setOpenUpdateAccountBalance(true)}
        >
          {translate("add_account_balance")}
        </Button>
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#E2EEFF",
            color: "black",
            ":hover": {
              backgroundColor: "#cce0fc"
            }
          }}
          onClick={() => setOpenUsagesAndLimits(true)}
        >
          {translate("usages_and_limits")}
        </Button>
      </Stack>
    </Stack>
  )

  return (
    <Stack
      gap={1}
      sx={{
        width: "100%"
      }}
    >
      {buttons}

      <SpecialOfferDialog
        isOpen={openSpecial}
        setClose={() => setOpenSpecial(false)}
      />
      <UpdateSpecialOffer
        isOpen={updateSpecial}
        setClose={() => setUpdateSpecial(false)}
        products={products}
      />

      <MarkPyementAsPaidDialog
        isOpen={openMarkPayement}
        setClose={() => setOpenMarkPayement(false)}
      />
      <ExtendReduceDialog
        isOpen={openExtendReduce}
        setClose={() => setOpenExtendReduce(false)}
      />
      <FeatureDialog
        isOpen={openFeature}
        setClose={() => setOpenFeature(false)}
      />
      <UpdateAccountBalance
        isOpen={openUpdateAccountBalance}
        setClose={() => setOpenUpdateAccountBalance(false)}
      />
      <SetAccountBalance
        isOpen={openSetAccountBalance}
        setClose={() => setOpenSetAccountBalance(false)}
      />
      <PlanLimitsAndUsages
        isOpen={openUsagesAndLimits}
        setClose={() => setOpenUsagesAndLimits(false)}
      />
      <AddCouponCodeDialog
        isOpen={openAddCouponCode}
        setClose={() => setOpenAddCouponCode(false)}
      />
      <RemoveCouponCodeDialog
        isOpen={openRemoveCouponCode}
        setClose={() => setOpenRemoveCouponCode(false)}
      />
      <UpgradePlanDialog
        isOpen={openUpgradePlan}
        setClose={() => setOpenUpgradePlan(false)}
        products={products}
      />
    </Stack>
  )
}
